export const IDS = 'entityIds';
export const BUSINESS_PARTNERS = 'businessPartnerIds';
